export const exampleData = {
  dateCreate: "2024-12-18T11:35:29.1376183Z",
  companyTitle: "",
  reportTitle: "График ТС",
  units: [
    {
      info: {
        id: "unitId",
        title: "Наименование ТС",
        registerNumber: "Госномер ТС",
        type: null,
        model: null,
        brand: null,
        settings: [],
      },
      days: [
        {
          day: "09.12.2024",
          rows: [
            {
              TI: "2024-12-09T07:40:00",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: null,
              FUELE: "126.2",
              FUELE1: "126.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: null,
              SATE: null,
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T07:41:00",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: null,
              FUELE: "126.2",
              FUELE1: "126.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: null,
              SATE: null,
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T07:42:00",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: null,
              FUELE: "126.2",
              FUELE1: "126.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: null,
              SATE: null,
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T07:43:00",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: null,
              FUELE: "126.2",
              FUELE1: "126.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: null,
              SATE: null,
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T07:44:00",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: null,
              FUELE: "126.2",
              FUELE1: "126.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: null,
              SATE: null,
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T07:45:00",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: null,
              FUELE: "126.2",
              FUELE1: "126.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: null,
              SATE: null,
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T07:46:00",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: null,
              FUELE: "126.2",
              FUELE1: "126.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: null,
              SATE: null,
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T07:47:00",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: null,
              FUELE: "126.2",
              FUELE1: "126.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: null,
              SATE: null,
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T07:48:00",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: null,
              FUELE: "126.2",
              FUELE1: "126.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: null,
              SATE: null,
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T07:49:00",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: null,
              FUELE: "126.2",
              FUELE1: "126.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: null,
              SATE: null,
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T07:50:00",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: null,
              FUELE: "126.2",
              FUELE1: "126.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: null,
              SATE: null,
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T07:51:00",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: null,
              FUELE: "126.2",
              FUELE1: "126.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: null,
              SATE: null,
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T07:52:00",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: null,
              FUELE: "126.2",
              FUELE1: "126.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: null,
              SATE: null,
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T07:53:00",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: null,
              FUELE: "126.2",
              FUELE1: "126.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: null,
              SATE: null,
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T07:54:00",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: null,
              FUELE: "126.2",
              FUELE1: "126.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: null,
              SATE: null,
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T07:55:00",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: null,
              FUELE: "126.2",
              FUELE1: "126.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: null,
              SATE: null,
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T07:56:00",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: null,
              FUELE: "126.2",
              FUELE1: "126.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: null,
              SATE: null,
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T07:57:00",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: null,
              FUELE: "126.2",
              FUELE1: "126.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: null,
              SATE: null,
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T07:58:00",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: null,
              FUELE: "126.2",
              FUELE1: "126.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: null,
              SATE: null,
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T07:59:00",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: null,
              FUELE: "126.2",
              FUELE1: "126.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: null,
              SATE: null,
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:00:01",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "66.4",
              FUELE1: "66.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "24.4",
              SATE: "5",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:00:31",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "66.4",
              FUELE1: "66.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "24.3",
              SATE: "9",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:01:01",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "66.4",
              FUELE1: "66.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "24.4",
              SATE: "9",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:01:31",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "66.4",
              FUELE1: "66.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "24.4",
              SATE: "11",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:02:01",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "66.4",
              FUELE1: "66.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "24.4",
              SATE: "11",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:02:31",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "66.4",
              FUELE1: "66.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "24.3",
              SATE: "11",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:03:01",
              IGNI: "False",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "66.4",
              FUELE1: "66.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "22.6",
              SATE: "11",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:03:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "66.3",
              FUELE1: "66.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "13",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:04:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "66.2",
              FUELE1: "66.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.7",
              SATE: "13",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:04:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "66.1",
              FUELE1: "66.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.7",
              SATE: "13",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:05:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "66.1",
              FUELE1: "66.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.7",
              SATE: "13",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:05:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "66.1",
              FUELE1: "66.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.7",
              SATE: "14",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:06:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "66.1",
              FUELE1: "66.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.7",
              SATE: "14",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:06:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "66",
              FUELE1: "66",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.7",
              SATE: "14",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:07:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "66",
              FUELE1: "66",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.8",
              SATE: "14",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:07:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.9",
              FUELE1: "65.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.8",
              SATE: "14",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:08:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.9",
              FUELE1: "65.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.8",
              SATE: "14",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:08:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.9",
              FUELE1: "65.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.8",
              SATE: "14",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:09:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.9",
              FUELE1: "65.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.7",
              SATE: "14",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:09:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.8",
              FUELE1: "65.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.7",
              SATE: "14",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:10:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.8",
              FUELE1: "65.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "14",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:10:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.7",
              FUELE1: "65.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.7",
              SATE: "12",
              FUEUP: "False",
              FUEDW: "True",
            },
            {
              TI: "2024-12-09T08:11:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.7",
              FUELE1: "65.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.7",
              SATE: "14",
              FUEUP: "False",
              FUEDW: "True",
              QUI: "True",
            },
            {
              TI: "2024-12-09T08:11:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.7",
              FUELE1: "65.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "14",
              FUEUP: "False",
              FUEDW: "True",
              QUI: "True",
            },
            {
              TI: "2024-12-09T08:12:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.7",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "True",
              QUI: "True",
            },
            {
              TI: "2024-12-09T08:12:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.7",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "True",
              QUI: "True",
            },
            {
              TI: "2024-12-09T08:12:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "True",
              QUI: "True",
            },
            {
              TI: "2024-12-09T08:13:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "True",
              QUI: "True",
            },
            {
              TI: "2024-12-09T08:13:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "True",
              QUI: "True",
            },
            {
              TI: "2024-12-09T08:14:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "True",
              QUI: "True",
            },
            {
              TI: "2024-12-09T08:14:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
              QUI: "True",
            },
            {
              TI: "2024-12-09T08:15:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
              QUI: "True",
            },
            {
              TI: "2024-12-09T08:15:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
              QUI: "True",
            },
            {
              TI: "2024-12-09T08:16:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
              QUI: "True",
            },
            {
              TI: "2024-12-09T08:16:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
              QUI: "True",
            },
            {
              TI: "2024-12-09T08:17:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
              QUI: "True",
            },
            {
              TI: "2024-12-09T08:17:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
              QUI: "True",
            },
            {
              TI: "2024-12-09T08:18:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
              QUI: "True",
            },
            {
              TI: "2024-12-09T08:18:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
              QUI: "True",
            },
            {
              TI: "2024-12-09T08:19:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
              QUI: "True",
            },
            {
              TI: "2024-12-09T08:19:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
              QUI: "True",
            },
            {
              TI: "2024-12-09T08:20:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:20:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
              QUI: "True",
            },
            {
              TI: "2024-12-09T08:21:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
              QUI: "True",
            },
            {
              TI: "2024-12-09T08:21:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:22:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:22:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:23:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:23:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:24:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:24:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.6",
              FUELE1: "65.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:25:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.5",
              FUELE1: "65.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
              DU1: "True",
            },
            {
              TI: "2024-12-09T08:25:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.5",
              FUELE1: "65.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
              DU1: "True",
            },
            {
              TI: "2024-12-09T08:26:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.5",
              FUELE1: "65.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
              DU1: "True",
            },
            {
              TI: "2024-12-09T08:26:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.5",
              FUELE1: "65.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
              DU1: "True",
            },
            {
              TI: "2024-12-09T08:27:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.5",
              FUELE1: "65.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.9",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
              DU1: "True",
            },
            {
              TI: "2024-12-09T08:27:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.5",
              FUELE1: "65.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
              DU1: "True",
            },
            {
              TI: "2024-12-09T08:28:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.5",
              FUELE1: "65.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
              DU1: "True",
            },
            {
              TI: "2024-12-09T08:28:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.5",
              FUELE1: "65.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:29:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.4",
              FUELE1: "65.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:29:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.4",
              FUELE1: "65.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:30:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.3",
              FUELE1: "65.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
              DU1: "True",
            },
            {
              TI: "2024-12-09T08:30:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.3",
              FUELE1: "65.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
              DU1: "True",
            },
            {
              TI: "2024-12-09T08:31:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.3",
              FUELE1: "65.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:31:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.3",
              FUELE1: "65.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:32:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.3",
              FUELE1: "65.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
              DU1: "True",
            },
            {
              TI: "2024-12-09T08:32:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.2",
              FUELE1: "65.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
              DU1: "True",
            },
            {
              TI: "2024-12-09T08:33:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.2",
              FUELE1: "65.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
              DU1: "True",
            },
            {
              TI: "2024-12-09T08:33:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.2",
              FUELE1: "65.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
              DU1: "True",
            },
            {
              TI: "2024-12-09T08:33:36",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.2",
              FUELE1: "65.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:33:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.2",
              FUELE1: "65.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:34:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.1",
              FUELE1: "65.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:34:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.1",
              FUELE1: "65.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:35:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.1",
              FUELE1: "65.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:35:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65",
              FUELE1: "65",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:36:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65",
              FUELE1: "65",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:36:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65",
              FUELE1: "65",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:37:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65",
              FUELE1: "65",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:37:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65",
              FUELE1: "65",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:38:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.9",
              FUELE1: "64.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:38:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.9",
              FUELE1: "64.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:39:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.9",
              FUELE1: "64.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:39:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.8",
              FUELE1: "64.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:40:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.8",
              FUELE1: "64.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:40:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.7",
              FUELE1: "64.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:41:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.7",
              FUELE1: "64.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:41:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.7",
              FUELE1: "64.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:41:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.7",
              FUELE1: "64.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:42:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.7",
              FUELE1: "64.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:42:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.7",
              FUELE1: "64.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:42:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.7",
              FUELE1: "64.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:42:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.7",
              FUELE1: "64.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
              SAND: "True",
            },
            {
              TI: "2024-12-09T08:43:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.6",
              FUELE1: "64.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
              SAND: "True",
            },
            {
              TI: "2024-12-09T08:43:38",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.6",
              FUELE1: "64.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
              SAND: "True",
            },
            {
              TI: "2024-12-09T08:44:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.6",
              FUELE1: "64.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:44:38",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.6",
              FUELE1: "64.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
              SAND: "True",
            },
            {
              TI: "2024-12-09T08:44:43",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.6",
              FUELE1: "64.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
              SAND: "True",
            },
            {
              TI: "2024-12-09T08:44:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.6",
              FUELE1: "64.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
              SAND: "True",
            },
            {
              TI: "2024-12-09T08:44:47",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.6",
              FUELE1: "64.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
              SAND: "True",
            },
            {
              TI: "2024-12-09T08:44:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.6",
              FUELE1: "64.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
              SAND: "True",
            },
            {
              TI: "2024-12-09T08:45:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.5",
              FUELE1: "64.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
              SAND: "True",
            },
            {
              TI: "2024-12-09T08:45:02",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.5",
              FUELE1: "64.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
              SAND: "True",
            },
            {
              TI: "2024-12-09T08:45:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.5",
              FUELE1: "64.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
              SAND: "True",
            },
            {
              TI: "2024-12-09T08:45:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.5",
              FUELE1: "64.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
              SAND: "True",
            },
            {
              TI: "2024-12-09T08:45:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.5",
              FUELE1: "64.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
              SAND: "True",
            },
            {
              TI: "2024-12-09T08:45:19",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.5",
              FUELE1: "64.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
              SAND: "True",
            },
            {
              TI: "2024-12-09T08:45:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.5",
              FUELE1: "64.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
              SAND: "True",
            },
            {
              TI: "2024-12-09T08:45:32",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.5",
              FUELE1: "64.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
              SAND: "True",
            },
            {
              TI: "2024-12-09T08:45:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.5",
              FUELE1: "64.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:45:38",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.5",
              FUELE1: "64.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:46:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.5",
              FUELE1: "64.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:46:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:46:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:46:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
              SAND: "True",
            },
            {
              TI: "2024-12-09T08:46:18",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:46:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:46:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:46:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:46:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:46:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:46:49",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:47:19",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
              SAND: "True",
            },
            {
              TI: "2024-12-09T08:47:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:47:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:47:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:47:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:48:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:48:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:48:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:48:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:48:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:49:11",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.3",
              FUELE1: "64.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:49:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.3",
              FUELE1: "64.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:49:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.3",
              FUELE1: "64.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:49:47",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.3",
              FUELE1: "64.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:50:17",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.3",
              FUELE1: "64.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
              SAND: "True",
            },
            {
              TI: "2024-12-09T08:50:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.3",
              FUELE1: "64.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:50:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.3",
              FUELE1: "64.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:50:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.2",
              FUELE1: "64.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:50:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.2",
              FUELE1: "64.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:51:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.2",
              FUELE1: "64.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:51:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.2",
              FUELE1: "64.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:51:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.2",
              FUELE1: "64.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:51:36",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.2",
              FUELE1: "64.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:52:06",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.1",
              FUELE1: "64.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:52:11",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.1",
              FUELE1: "64.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:52:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.1",
              FUELE1: "64.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:52:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.1",
              FUELE1: "64.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:52:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.1",
              FUELE1: "64.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:52:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.1",
              FUELE1: "64.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:53:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.1",
              FUELE1: "64.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:53:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.1",
              FUELE1: "64.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:54:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.1",
              FUELE1: "64.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:54:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.1",
              FUELE1: "64.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:54:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64",
              FUELE1: "64",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:54:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64",
              FUELE1: "64",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:55:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64",
              FUELE1: "64",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:55:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64",
              FUELE1: "64",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:55:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64",
              FUELE1: "64",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              SAND: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:55:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64",
              FUELE1: "64",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:56:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64",
              FUELE1: "64",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:56:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64",
              FUELE1: "64",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:56:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:57:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:57:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:57:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:57:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:57:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:57:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:57:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:57:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:58:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:58:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:58:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:58:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:58:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:59:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.8",
              FUELE1: "63.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:59:17",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.8",
              FUELE1: "63.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:59:18",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.8",
              FUELE1: "63.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:59:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.8",
              FUELE1: "63.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:59:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.8",
              FUELE1: "63.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T08:59:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.8",
              FUELE1: "63.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:00:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.8",
              FUELE1: "63.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:00:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.8",
              FUELE1: "63.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:00:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.7",
              FUELE1: "63.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:00:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.7",
              FUELE1: "63.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:01:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.7",
              FUELE1: "63.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:01:11",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.7",
              FUELE1: "63.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:01:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.7",
              FUELE1: "63.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:01:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.7",
              FUELE1: "63.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:01:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.7",
              FUELE1: "63.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:01:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.7",
              FUELE1: "63.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:01:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.7",
              FUELE1: "63.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:01:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.7",
              FUELE1: "63.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:01:43",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.7",
              FUELE1: "63.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:01:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.7",
              FUELE1: "63.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:01:49",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.7",
              FUELE1: "63.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:02:19",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.6",
              FUELE1: "63.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:02:49",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.6",
              FUELE1: "63.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:03:19",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.6",
              FUELE1: "63.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:03:49",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.6",
              FUELE1: "63.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:03:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.6",
              FUELE1: "63.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:03:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.6",
              FUELE1: "63.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:04:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.6",
              FUELE1: "63.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:04:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.6",
              FUELE1: "63.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:04:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.6",
              FUELE1: "63.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:05:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.5",
              FUELE1: "63.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:05:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.5",
              FUELE1: "63.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:06:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.5",
              FUELE1: "63.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:06:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:06:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:06:50",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.8",
              FUELE1: "63.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:06:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.8",
              FUELE1: "63.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:07:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.3",
              FUELE1: "63.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:07:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.5",
              FUELE1: "64.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:08:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64",
              FUELE1: "64",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:08:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64",
              FUELE1: "64",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:08:17",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64",
              FUELE1: "64",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:08:47",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:09:17",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:09:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:09:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:09:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:09:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:10:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:10:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:11:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:11:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:11:36",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:12:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.8",
              FUELE1: "63.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:12:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.6",
              FUELE1: "63.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.3",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:12:11",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.6",
              FUELE1: "63.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:12:19",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:12:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.2",
              FUELE1: "64.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:12:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.2",
              FUELE1: "64.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:12:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.2",
              FUELE1: "64",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:12:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.2",
              FUELE1: "64",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:13:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.5",
              FUELE1: "65.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.3",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:13:06",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.5",
              FUELE1: "65.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.3",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:13:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65.5",
              FUELE1: "64.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:13:38",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.7",
              FUELE1: "64.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:13:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:13:49",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.9",
              FUELE1: "63.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:14:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.7",
              FUELE1: "64.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:14:06",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.3",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:14:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.4",
              FUELE1: "64.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:14:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "65",
              FUELE1: "65",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:14:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.9",
              FUELE1: "63.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:14:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.6",
              FUELE1: "63.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:14:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.2",
              FUELE1: "63.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:14:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.2",
              FUELE1: "63.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.3",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:14:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.2",
              FUELE1: "63.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:14:38",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.4",
              FUELE1: "63.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.3",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:14:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.4",
              FUELE1: "63.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:14:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "62.7",
              FUELE1: "62.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:15:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "62.7",
              FUELE1: "62.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:15:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.7",
              FUELE1: "64.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:15:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.7",
              FUELE1: "64.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:15:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.6",
              FUELE1: "64.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:15:49",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.6",
              FUELE1: "64.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.3",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:15:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.6",
              FUELE1: "64.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.3",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:16:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64",
              FUELE1: "64",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:16:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "63.2",
              FUELE1: "63.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:16:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.1",
              FUELE1: "64.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:16:17",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "64.1",
              FUELE1: "64.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:16:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "62.4",
              FUELE1: "62.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:16:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.7",
              FUELE1: "61.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:17:06",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "62.4",
              FUELE1: "62.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:17:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "62.4",
              FUELE1: "62.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:17:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "62.2",
              FUELE1: "62.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:17:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "62.2",
              FUELE1: "62.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:17:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.7",
              FUELE1: "61.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:17:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.7",
              FUELE1: "61.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:17:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.5",
              FUELE1: "61.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:18:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.5",
              FUELE1: "61.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:18:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.5",
              FUELE1: "61.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:19:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:19:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:20:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:20:33",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:20:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:20:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:20:38",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:20:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:20:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:21:02",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:21:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:21:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:21:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:21:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:21:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:21:49",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:22:19",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.3",
              FUELE1: "61.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:22:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.3",
              FUELE1: "61.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:22:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.3",
              FUELE1: "61.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:22:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.3",
              FUELE1: "61.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:23:02",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.3",
              FUELE1: "61.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:23:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.3",
              FUELE1: "61.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:23:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.3",
              FUELE1: "61.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:23:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.3",
              FUELE1: "61.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:23:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.3",
              FUELE1: "61.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:23:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.3",
              FUELE1: "61.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:23:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "62.7",
              FUELE1: "62.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:23:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "62.7",
              FUELE1: "61.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:23:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.5",
              FUELE1: "61.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:23:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.5",
              FUELE1: "61.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:24:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:24:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:24:11",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:24:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:24:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:24:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:25:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:25:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:25:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:25:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:25:19",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:25:20",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:25:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:25:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:25:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:25:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:25:49",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:25:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:25:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:26:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:26:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:26:36",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:26:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:26:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:26:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:26:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:27:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:27:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:28:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:28:06",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:28:36",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.9",
              FUELE1: "60.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:28:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.9",
              FUELE1: "60.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:28:50",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.9",
              FUELE1: "60.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:28:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.9",
              FUELE1: "60.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:29:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.9",
              FUELE1: "60.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:29:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.9",
              FUELE1: "60.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:29:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.9",
              FUELE1: "60.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:29:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.9",
              FUELE1: "60.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:29:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.9",
              FUELE1: "60.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:29:20",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:29:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:29:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.6",
              FUELE1: "61.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:29:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.6",
              FUELE1: "61.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:29:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.8",
              FUELE1: "61.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:29:47",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.8",
              FUELE1: "61.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:30:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.9",
              FUELE1: "61.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:30:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.8",
              FUELE1: "61.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:30:06",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.8",
              FUELE1: "61.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:30:36",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.7",
              FUELE1: "61.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:30:43",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.7",
              FUELE1: "61.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:30:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.7",
              FUELE1: "61.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:31:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.7",
              FUELE1: "61.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:31:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.7",
              FUELE1: "61.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:31:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.7",
              FUELE1: "61.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:31:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.7",
              FUELE1: "61.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:32:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.7",
              FUELE1: "61.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:32:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.7",
              FUELE1: "61.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:32:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.7",
              FUELE1: "61.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:33:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.7",
              FUELE1: "61.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:33:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.7",
              FUELE1: "61.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:33:43",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.7",
              FUELE1: "61.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:33:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.7",
              FUELE1: "61.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:33:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.7",
              FUELE1: "61.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:33:47",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.7",
              FUELE1: "61.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:34:17",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.6",
              FUELE1: "61.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:34:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.6",
              FUELE1: "61.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:34:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.6",
              FUELE1: "61.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:34:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.6",
              FUELE1: "61.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:35:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.6",
              FUELE1: "61.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:35:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.6",
              FUELE1: "61.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:35:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.6",
              FUELE1: "61.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:35:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.6",
              FUELE1: "61.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:35:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.6",
              FUELE1: "61.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:35:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.5",
              FUELE1: "61.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:36:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.5",
              FUELE1: "61.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:36:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.5",
              FUELE1: "61.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:36:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.5",
              FUELE1: "61.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:36:38",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.5",
              FUELE1: "61.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:36:47",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.5",
              FUELE1: "61.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:36:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.5",
              FUELE1: "61.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:36:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.5",
              FUELE1: "61.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:36:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.5",
              FUELE1: "61.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:37:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:37:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:38:02",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:38:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:38:33",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:38:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:38:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:38:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:38:47",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:39:17",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:39:47",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:39:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:39:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:39:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:39:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:40:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.3",
              FUELE1: "61.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:40:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.3",
              FUELE1: "61.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:41:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.3",
              FUELE1: "61.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:41:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:42:06",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:42:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:42:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:42:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:42:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:42:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:42:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:43:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:43:36",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:43:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:44:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:44:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:44:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:44:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:45:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:45:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:45:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:45:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:46:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:46:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:47:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:47:06",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:47:36",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:47:43",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:47:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:47:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:47:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:48:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:48:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:48:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:48:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:48:17",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:48:47",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:49:17",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:49:47",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.9",
              FUELE1: "60.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:49:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.9",
              FUELE1: "60.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:49:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.9",
              FUELE1: "60.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:50:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.9",
              FUELE1: "60.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:50:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.9",
              FUELE1: "60.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:50:32",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.9",
              FUELE1: "60.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:51:02",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.8",
              FUELE1: "60.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:51:32",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.8",
              FUELE1: "60.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:51:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.8",
              FUELE1: "60.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:51:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.8",
              FUELE1: "60.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:52:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.8",
              FUELE1: "60.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:52:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.8",
              FUELE1: "60.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:53:02",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.8",
              FUELE1: "60.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:53:32",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.8",
              FUELE1: "60.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:54:02",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.7",
              FUELE1: "60.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:54:32",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.7",
              FUELE1: "60.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:55:02",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.7",
              FUELE1: "60.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:55:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.7",
              FUELE1: "60.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:55:11",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.7",
              FUELE1: "60.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:55:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.7",
              FUELE1: "60.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:55:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.7",
              FUELE1: "60.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:55:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.6",
              FUELE1: "60.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:56:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.6",
              FUELE1: "60.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:56:06",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.6",
              FUELE1: "60.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:56:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.6",
              FUELE1: "60.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:56:11",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.6",
              FUELE1: "60.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:56:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60",
              FUELE1: "60",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:56:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60",
              FUELE1: "60",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:56:49",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.8",
              FUELE1: "58.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:56:50",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.8",
              FUELE1: "58.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:56:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.8",
              FUELE1: "58.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:56:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.8",
              FUELE1: "58.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:56:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.8",
              FUELE1: "58.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:56:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.8",
              FUELE1: "58.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:57:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.8",
              FUELE1: "59.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:57:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.2",
              FUELE1: "59.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:57:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "3",
              FUELE: "58.9",
              FUELE1: "58.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:57:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "3",
              FUELE: "58.9",
              FUELE1: "58.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:57:47",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "4",
              FUELE: "58.5",
              FUELE1: "57",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:57:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "5",
              FUELE: "58.2",
              FUELE1: "56.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:57:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "5",
              FUELE: "57.9",
              FUELE1: "56.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:57:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.7",
              FUELE1: "56.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:58:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.4",
              FUELE1: "59.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:58:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.4",
              FUELE1: "59.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:58:19",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.5",
              FUELE1: "57.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:58:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.5",
              FUELE1: "57.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:58:38",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.8",
              FUELE1: "58.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:58:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.8",
              FUELE1: "58.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:58:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.8",
              FUELE1: "58.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:58:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.6",
              FUELE1: "58.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:58:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.6",
              FUELE1: "58.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:59:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.8",
              FUELE1: "58.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:59:06",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.8",
              FUELE1: "58.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:59:36",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.8",
              FUELE1: "58.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:59:43",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.8",
              FUELE1: "58.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:59:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.8",
              FUELE1: "58.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:59:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.8",
              FUELE1: "58.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T09:59:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.8",
              FUELE1: "58.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:00:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.8",
              FUELE1: "58.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:00:02",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.8",
              FUELE1: "58.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:00:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.7",
              FUELE1: "60.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:00:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.7",
              FUELE1: "60.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:01:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.3",
              FUELE1: "59.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:01:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.7",
              FUELE1: "58.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:01:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.7",
              FUELE1: "58.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:01:33",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.9",
              FUELE1: "58.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:01:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:01:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.7",
              FUELE1: "61.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:01:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.7",
              FUELE1: "61.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:01:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:01:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:02:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.3",
              FUELE1: "61.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:02:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.3",
              FUELE1: "61.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:02:20",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:02:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:02:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.2",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:03:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.3",
              FUELE1: "61.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.2",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:03:51",
              IGNI: "True",
              TE: "0",
              FUEF: "20",
              SPEE: "0",
              FUELE: "61.3",
              FUELE1: "61.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:04:21",
              IGNI: "True",
              TE: "0",
              FUEF: "15",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.1",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:04:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:05:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:05:51",
              IGNI: "True",
              TE: "0",
              FUEF: "20",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:06:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:06:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:07:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:07:51",
              IGNI: "True",
              TE: "0",
              FUEF: "20",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:08:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:08:51",
              IGNI: "True",
              TE: "0",
              FUEF: "10",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:09:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:09:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:10:21",
              IGNI: "True",
              TE: "0",
              FUEF: "40",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:10:51",
              IGNI: "True",
              TE: "0",
              FUEF: "50",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:11:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:11:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:12:21",
              IGNI: "True",
              TE: "0",
              FUEF: "60",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:12:51",
              IGNI: "True",
              TE: "0",
              FUEF: "30",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:13:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:13:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:14:21",
              IGNI: "True",
              TE: "0",
              FUEF: "50",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:14:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:15:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:15:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:16:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:16:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:17:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:17:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:18:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:18:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:19:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:19:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:20:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:20:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:21:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:21:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:22:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:22:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:23:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:23:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:23:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:24:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:24:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:25:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:25:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:26:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:26:32",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:26:33",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:27:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:27:33",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:27:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:27:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:28:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:28:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:28:17",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:28:47",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:28:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:28:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:29:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:29:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:29:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:30:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:30:06",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:30:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:30:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:31:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:31:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:31:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:31:43",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:32:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:32:43",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:33:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:33:18",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:33:19",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:33:49",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:34:19",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:34:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:34:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:34:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:35:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:35:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:36:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:36:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:37:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:37:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:38:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:38:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:39:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:39:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:40:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:40:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:41:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:41:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:42:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:42:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:43:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.9",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:43:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.9",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:44:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.9",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:44:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.9",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:45:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.9",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:45:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.9",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:46:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.9",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:46:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.9",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:47:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.9",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:47:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.9",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:48:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.9",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:48:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.9",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:49:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.9",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:49:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.9",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:50:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:50:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.9",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:51:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.9",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:51:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.9",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:52:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.9",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:52:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.9",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:53:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.9",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:53:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:54:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:54:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:55:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:55:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:56:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:56:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:57:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:57:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:58:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:58:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:59:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T10:59:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:00:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:00:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:01:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:01:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:02:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:02:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:03:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:03:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:04:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:04:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:04:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:04:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.7",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:05:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:05:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:06:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:06:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:07:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:07:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.7",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:07:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:07:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.7",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:08:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.7",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:08:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:08:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.7",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:08:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.7",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:09:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.7",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:09:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.7",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:10:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.8",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:10:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.7",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:10:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.7",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:10:47",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.7",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:10:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "25.7",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:11:18",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.1",
              FUELE1: "61.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:11:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:11:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:11:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "61.2",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:11:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "3",
              FUELE: "61.4",
              FUELE1: "61.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:11:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "3",
              FUELE: "61.4",
              FUELE1: "62.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:11:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "4",
              FUELE: "61.5",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:11:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "3",
              FUELE: "61.4",
              FUELE1: "61",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:11:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "3",
              FUELE: "60.9",
              FUELE1: "58.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:12:06",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "4",
              FUELE: "60.4",
              FUELE1: "58.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:12:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "4",
              FUELE: "60.4",
              FUELE1: "60.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:12:18",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "5",
              FUELE: "60.2",
              FUELE1: "59.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:12:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "4",
              FUELE: "60.2",
              FUELE1: "60.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:12:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.2",
              FUELE1: "60.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:12:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59",
              FUELE1: "59",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:12:33",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.8",
              FUELE1: "58",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:13:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.3",
              FUELE1: "61.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:13:33",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.3",
              FUELE1: "60.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:13:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.3",
              FUELE1: "60.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:13:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.3",
              FUELE1: "60.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:14:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.2",
              FUELE1: "59.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:14:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.8",
              FUELE1: "59.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:14:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.6",
              FUELE1: "59.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:14:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.6",
              FUELE1: "59.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:14:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.7",
              FUELE1: "59.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:14:47",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.7",
              FUELE1: "59.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:15:17",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.3",
              FUELE1: "59.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:15:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.3",
              FUELE1: "59.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:15:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.3",
              FUELE1: "59.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:15:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.5",
              FUELE1: "59.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:16:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.3",
              FUELE1: "59.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:16:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.3",
              FUELE1: "59.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:16:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.3",
              FUELE1: "59.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:17:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.2",
              FUELE1: "59.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:17:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "60.6",
              FUELE1: "60.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:18:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59",
              FUELE1: "59",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:18:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.1",
              FUELE1: "59.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:19:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.1",
              FUELE1: "59.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:19:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59.1",
              FUELE1: "59.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:20:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "59",
              FUELE1: "59",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:20:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.4",
              FUELE1: "58.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:20:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.5",
              FUELE1: "58.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:21:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.5",
              FUELE1: "58.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:21:18",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.5",
              FUELE1: "58.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:21:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.5",
              FUELE1: "58.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:21:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57",
              FUELE1: "57",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:22:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.1",
              FUELE1: "58.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:22:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.1",
              FUELE1: "58.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:22:33",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.1",
              FUELE1: "58.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:23:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.2",
              FUELE1: "58.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:23:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.2",
              FUELE1: "58.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:23:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.2",
              FUELE1: "58.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:23:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.2",
              FUELE1: "58.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:24:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.1",
              FUELE1: "58.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:24:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.9",
              FUELE1: "57.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:24:43",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.9",
              FUELE1: "57.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:24:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.9",
              FUELE1: "57.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:25:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.3",
              FUELE1: "58.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:25:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.5",
              FUELE1: "57.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:26:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.8",
              FUELE1: "57.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:26:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.8",
              FUELE1: "57.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:27:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.4",
              FUELE1: "57.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:27:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.2",
              FUELE1: "57.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:27:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.2",
              FUELE1: "57.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:27:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.7",
              FUELE1: "57.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:28:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.7",
              FUELE1: "57.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:28:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.7",
              FUELE1: "57.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:28:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.3",
              FUELE1: "58.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:28:17",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.3",
              FUELE1: "58.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:28:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.8",
              FUELE1: "57.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:28:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.8",
              FUELE1: "57.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:28:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.1",
              FUELE1: "57.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:29:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.7",
              FUELE1: "58.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:29:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.3",
              FUELE1: "57.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:29:32",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.3",
              FUELE1: "57.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:30:02",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.1",
              FUELE1: "58.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:30:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.1",
              FUELE1: "56.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:30:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.1",
              FUELE1: "56.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:30:20",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.7",
              FUELE1: "57.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:30:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.7",
              FUELE1: "57.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:30:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.2",
              FUELE1: "57.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:31:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57",
              FUELE1: "57",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:31:02",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57",
              FUELE1: "57",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:31:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.9",
              FUELE1: "56.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:31:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.9",
              FUELE1: "56.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:31:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57",
              FUELE1: "57",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:31:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57",
              FUELE1: "57",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:31:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.8",
              FUELE1: "56.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:32:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "58.1",
              FUELE1: "58.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:32:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.6",
              FUELE1: "56.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:33:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.8",
              FUELE1: "57.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:33:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.8",
              FUELE1: "57.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:33:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.5",
              FUELE1: "56.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:33:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.5",
              FUELE1: "56.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:33:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.5",
              FUELE1: "56.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:33:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.2",
              FUELE1: "57.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:33:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.1",
              FUELE1: "57.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:33:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.1",
              FUELE1: "57.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:34:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.5",
              FUELE1: "57.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:34:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.5",
              FUELE1: "57",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:34:19",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.6",
              FUELE1: "57.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:34:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.6",
              FUELE1: "57.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:34:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.1",
              FUELE1: "57.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:35:02",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.6",
              FUELE1: "56.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:35:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.6",
              FUELE1: "56.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:35:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.7",
              FUELE1: "56.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:35:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.7",
              FUELE1: "56.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:35:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.7",
              FUELE1: "56.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:35:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.7",
              FUELE1: "56.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:35:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.7",
              FUELE1: "57.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:36:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57",
              FUELE1: "57",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:36:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57",
              FUELE1: "57",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:36:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.7",
              FUELE1: "57.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:36:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.6",
              FUELE1: "57.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:36:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.6",
              FUELE1: "57.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:36:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.6",
              FUELE1: "57.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:36:50",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.5",
              FUELE1: "56.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:36:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.9",
              FUELE1: "56.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:36:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.9",
              FUELE1: "56.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:36:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.9",
              FUELE1: "56.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:36:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.9",
              FUELE1: "57.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:37:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.4",
              FUELE1: "57.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:37:33",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "3",
              FUELE: "57.2",
              FUELE1: "57.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:37:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "3",
              FUELE: "57.2",
              FUELE1: "57.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:37:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "3",
              FUELE: "57.4",
              FUELE1: "57.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:37:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.5",
              FUELE1: "57.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:38:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.2",
              FUELE1: "56.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:38:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.9",
              FUELE1: "55.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:38:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.9",
              FUELE1: "55.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:38:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.3",
              FUELE1: "56.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:38:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.3",
              FUELE1: "56.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:38:33",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.1",
              FUELE1: "56.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:38:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.1",
              FUELE1: "56.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:39:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.4",
              FUELE1: "55.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:39:11",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "4",
              FUELE: "55.6",
              FUELE1: "55.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:39:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "7",
              FUELE: "55.6",
              FUELE1: "55.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:39:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "6",
              FUELE: "55.5",
              FUELE1: "55",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:39:17",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.4",
              FUELE1: "55",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:39:47",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56",
              FUELE1: "56",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:39:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.1",
              FUELE1: "56.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:39:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.1",
              FUELE1: "56.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:40:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.1",
              FUELE1: "56.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:40:06",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56",
              FUELE1: "55.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:40:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.7",
              FUELE1: "55.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:40:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.7",
              FUELE1: "55.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:40:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.3",
              FUELE1: "56.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:40:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.3",
              FUELE1: "55.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:40:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.7",
              FUELE1: "55.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:40:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.7",
              FUELE1: "55.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:41:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.3",
              FUELE1: "56.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:41:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.2",
              FUELE1: "56.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:41:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.4",
              FUELE1: "55.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:41:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.4",
              FUELE1: "55.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:42:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.1",
              FUELE1: "55.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:42:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.1",
              FUELE1: "55.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:42:32",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.1",
              FUELE1: "55.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:42:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.3",
              FUELE1: "56.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:42:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.3",
              FUELE1: "56.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:43:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.6",
              FUELE1: "55.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:43:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55",
              FUELE1: "55",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:43:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55",
              FUELE1: "55",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:44:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.2",
              FUELE1: "55.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:44:11",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "54.9",
              FUELE1: "54.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:44:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "54.9",
              FUELE1: "54.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:44:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.9",
              FUELE1: "55.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:44:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.8",
              FUELE1: "53.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:44:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.8",
              FUELE1: "52.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:45:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.4",
              FUELE1: "53.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:45:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.4",
              FUELE1: "53.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:45:17",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57",
              FUELE1: "57",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:45:18",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57",
              FUELE1: "57",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:45:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.4",
              FUELE1: "57.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:45:32",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.4",
              FUELE1: "57.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:46:02",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "57.7",
              FUELE1: "57.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:46:32",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "56.6",
              FUELE1: "56.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:47:02",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55",
              FUELE1: "55",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:47:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.1",
              FUELE1: "55.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:47:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.1",
              FUELE1: "55.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:47:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.1",
              FUELE1: "55.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:47:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.1",
              FUELE1: "55.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:47:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.4",
              FUELE1: "55.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:47:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "54.3",
              FUELE1: "54.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:47:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "54.3",
              FUELE1: "53.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:48:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "54.1",
              FUELE1: "54.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:48:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "54.1",
              FUELE1: "54.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:48:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "54.1",
              FUELE1: "54.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:48:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "54.1",
              FUELE1: "54.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:48:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.6",
              FUELE1: "53.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:48:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.6",
              FUELE1: "53.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:48:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53",
              FUELE1: "53",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:48:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53",
              FUELE1: "52.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:48:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.6",
              FUELE1: "52.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:49:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.4",
              FUELE1: "53.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:49:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.4",
              FUELE1: "53.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:49:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "54.3",
              FUELE1: "54.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:50:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55",
              FUELE1: "55",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:50:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.2",
              FUELE1: "55.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:50:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "55.4",
              FUELE1: "55.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:50:50",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "54.8",
              FUELE1: "54.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:50:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "54.8",
              FUELE1: "54.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:51:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.7",
              FUELE1: "53.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:51:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.7",
              FUELE1: "53.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:51:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.7",
              FUELE1: "53.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:51:38",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "7",
              FUELE: "53",
              FUELE1: "53",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:51:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "3",
              FUELE: "53",
              FUELE1: "53.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:51:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "3",
              FUELE: "53.2",
              FUELE1: "53.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:51:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.3",
              FUELE1: "53.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:52:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.3",
              FUELE1: "52.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:52:20",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.9",
              FUELE1: "52.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:52:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.9",
              FUELE1: "52.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:52:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.9",
              FUELE1: "52.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:52:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53",
              FUELE1: "53.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:52:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53",
              FUELE1: "53",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:52:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53",
              FUELE1: "53",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:52:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53",
              FUELE1: "53",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:53:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53",
              FUELE1: "53",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:53:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53",
              FUELE1: "53",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:53:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53",
              FUELE1: "53",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:53:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53",
              FUELE1: "53",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:53:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53",
              FUELE1: "53",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:53:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.4",
              FUELE1: "52.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:53:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.4",
              FUELE1: "52.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:54:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.4",
              FUELE1: "52.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:54:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.3",
              FUELE1: "52.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:54:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.3",
              FUELE1: "52.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:54:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.8",
              FUELE1: "51.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:54:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.8",
              FUELE1: "51.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:54:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.6",
              FUELE1: "51.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:54:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.6",
              FUELE1: "51.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:54:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.4",
              FUELE1: "52.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:55:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:55:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "54.2",
              FUELE1: "54.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:56:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.4",
              FUELE1: "53.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:56:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.4",
              FUELE1: "52.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:56:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.5",
              FUELE1: "52.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:56:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.4",
              FUELE1: "52.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:56:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.4",
              FUELE1: "52.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:56:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.2",
              FUELE1: "53.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:56:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.2",
              FUELE1: "53.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:57:06",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.6",
              FUELE1: "52.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:57:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.6",
              FUELE1: "52.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:57:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.3",
              FUELE1: "53.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:57:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.7",
              FUELE1: "53.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "14",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:57:50",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.7",
              FUELE1: "53.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:57:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.7",
              FUELE1: "53.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:57:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.7",
              FUELE1: "53.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:58:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.1",
              FUELE1: "53.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:58:32",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53",
              FUELE1: "53",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:58:33",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53",
              FUELE1: "53",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:59:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.8",
              FUELE1: "52.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:59:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.8",
              FUELE1: "52.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:59:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.8",
              FUELE1: "52.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:59:11",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.8",
              FUELE1: "52.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:59:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.8",
              FUELE1: "52.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T11:59:43",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.8",
              FUELE1: "52.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:00:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.8",
              FUELE1: "52.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:00:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.8",
              FUELE1: "52.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:00:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.8",
              FUELE1: "52.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:00:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.8",
              FUELE1: "52.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:00:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.8",
              FUELE1: "52.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:00:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.7",
              FUELE1: "52.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:01:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.7",
              FUELE1: "52.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:01:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.7",
              FUELE1: "52.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:01:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.6",
              FUELE1: "51.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:02:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.5",
              FUELE1: "52.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:02:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.5",
              FUELE1: "52.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:02:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.5",
              FUELE1: "52.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:02:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.3",
              FUELE1: "52.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:02:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.3",
              FUELE1: "52.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:02:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.3",
              FUELE1: "52.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:02:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.3",
              FUELE1: "52.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:03:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.3",
              FUELE1: "52.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:03:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.3",
              FUELE1: "52.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:04:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.3",
              FUELE1: "52.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:04:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.3",
              FUELE1: "52.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:04:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.3",
              FUELE1: "52.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:04:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.3",
              FUELE1: "52.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:05:11",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.3",
              FUELE1: "52.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:05:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.3",
              FUELE1: "52.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:06:11",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.2",
              FUELE1: "52.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:06:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.2",
              FUELE1: "52.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:06:50",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.2",
              FUELE1: "52.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:06:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.2",
              FUELE1: "52.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:07:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:07:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:08:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:08:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:08:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:08:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:08:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:09:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:09:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:09:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:09:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:09:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:09:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:10:02",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:10:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:10:06",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:10:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:10:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:10:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:10:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52",
              FUELE1: "52",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:11:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.5",
              FUELE1: "51.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.2",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:11:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.9",
              FUELE1: "51.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.1",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:11:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.9",
              FUELE1: "51.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.2",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:12:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.7",
              FUELE1: "51.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.1",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:12:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.7",
              FUELE1: "51.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.1",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:12:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.7",
              FUELE1: "51.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.1",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:12:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.7",
              FUELE1: "51.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.1",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:13:11",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.7",
              FUELE1: "51.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:13:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.6",
              FUELE1: "51.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:13:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.6",
              FUELE1: "51.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:13:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.6",
              FUELE1: "51.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:14:18",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.6",
              FUELE1: "51.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:14:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.6",
              FUELE1: "51.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:14:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.6",
              FUELE1: "51.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:14:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.6",
              FUELE1: "51.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:15:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.6",
              FUELE1: "51.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:15:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.6",
              FUELE1: "51.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:16:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.6",
              FUELE1: "51.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:16:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.6",
              FUELE1: "51.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:17:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.6",
              FUELE1: "51.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:17:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52",
              FUELE1: "52",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:17:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.6",
              FUELE1: "50.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:18:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.7",
              FUELE1: "50.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:18:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.7",
              FUELE1: "50.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:18:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.7",
              FUELE1: "50.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:19:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.7",
              FUELE1: "50.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:19:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.6",
              FUELE1: "50.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:20:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.3",
              FUELE1: "51.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:20:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.5",
              FUELE1: "51.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:20:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.5",
              FUELE1: "51.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:20:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.6",
              FUELE1: "51.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:20:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.6",
              FUELE1: "51.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:20:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.3",
              FUELE1: "51.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:20:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.3",
              FUELE1: "51.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:20:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.3",
              FUELE1: "51.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:21:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.6",
              FUELE1: "50.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:21:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:22:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:22:06",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "51.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:22:36",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.4",
              FUELE1: "50.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:22:38",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.3",
              FUELE1: "50.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:22:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.3",
              FUELE1: "50.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:23:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:23:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.2",
              FUELE1: "53.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:24:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "52.1",
              FUELE1: "52.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:24:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50",
              FUELE1: "50",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:24:49",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.3",
              FUELE1: "49.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:24:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.3",
              FUELE1: "49.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:24:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.7",
              FUELE1: "49.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:24:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.7",
              FUELE1: "49.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:25:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.3",
              FUELE1: "50.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:25:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.2",
              FUELE1: "50.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:26:06",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "3",
              FUELE: "50.1",
              FUELE1: "50.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:26:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "3",
              FUELE: "50.1",
              FUELE1: "50.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:26:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "4",
              FUELE: "50.1",
              FUELE1: "50.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:26:11",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.1",
              FUELE1: "50.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:26:18",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.1",
              FUELE1: "50.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:26:19",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.1",
              FUELE1: "50.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:26:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.1",
              FUELE1: "50.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:26:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.1",
              FUELE1: "50.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:26:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.1",
              FUELE1: "50.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:26:38",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.1",
              FUELE1: "50.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:26:43",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.1",
              FUELE1: "50.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:26:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.1",
              FUELE1: "50.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:27:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.1",
              FUELE1: "50.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:27:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.1",
              FUELE1: "50.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:27:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.1",
              FUELE1: "50.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:27:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.1",
              FUELE1: "50.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:27:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.1",
              FUELE1: "50.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:27:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.1",
              FUELE1: "50.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:27:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.1",
              FUELE1: "50.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:28:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.1",
              FUELE1: "50.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:28:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50",
              FUELE1: "50",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:29:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50",
              FUELE1: "50",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:29:06",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50",
              FUELE1: "50",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:29:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50",
              FUELE1: "50",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:29:17",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50",
              FUELE1: "50",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:29:18",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50",
              FUELE1: "50",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:29:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.5",
              FUELE1: "50.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:29:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.5",
              FUELE1: "50.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:29:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.5",
              FUELE1: "50.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:29:36",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.5",
              FUELE1: "50.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:29:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.9",
              FUELE1: "51.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:29:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.9",
              FUELE1: "51.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:29:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.1",
              FUELE1: "50.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:29:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.1",
              FUELE1: "49.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:30:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.6",
              FUELE1: "50.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:30:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.6",
              FUELE1: "49.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:30:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.8",
              FUELE1: "49.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:30:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.8",
              FUELE1: "49",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:30:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.5",
              FUELE1: "49.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:30:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.4",
              FUELE1: "50.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:30:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.4",
              FUELE1: "50.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:31:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.3",
              FUELE1: "49.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:31:38",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.8",
              FUELE1: "49.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:31:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.8",
              FUELE1: "49.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:31:49",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.2",
              FUELE1: "49.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:31:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.2",
              FUELE1: "50.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:32:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.4",
              FUELE1: "50.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:32:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.1",
              FUELE1: "49.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:32:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.3",
              FUELE1: "50.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:32:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.3",
              FUELE1: "50.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:32:18",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.5",
              FUELE1: "49.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:32:20",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.5",
              FUELE1: "49.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:32:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.6",
              FUELE1: "48.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:32:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.4",
              FUELE1: "49.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:32:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.4",
              FUELE1: "49.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:33:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.5",
              FUELE1: "51.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:33:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.8",
              FUELE1: "49.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:33:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.7",
              FUELE1: "48.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:33:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.7",
              FUELE1: "48.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:33:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.7",
              FUELE1: "48.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:33:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.7",
              FUELE1: "49.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:33:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.2",
              FUELE1: "49.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:33:50",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.2",
              FUELE1: "49.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:34:20",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.9",
              FUELE1: "48.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:34:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.2",
              FUELE1: "50.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:34:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.2",
              FUELE1: "50.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:34:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.1",
              FUELE1: "49.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:35:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.1",
              FUELE1: "48.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:35:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.6",
              FUELE1: "51.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:35:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.6",
              FUELE1: "51.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:36:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.8",
              FUELE1: "50.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:36:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.7",
              FUELE1: "50.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:36:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.7",
              FUELE1: "50.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:36:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.8",
              FUELE1: "51.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:36:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.3",
              FUELE1: "51.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:36:18",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.3",
              FUELE1: "50.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:36:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.6",
              FUELE1: "49.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:36:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.6",
              FUELE1: "49.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:36:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.7",
              FUELE1: "47.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:36:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.7",
              FUELE1: "47.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:36:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.7",
              FUELE1: "47.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:36:38",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.4",
              FUELE1: "49.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:36:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.4",
              FUELE1: "49.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:36:47",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "53.4",
              FUELE1: "53.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:37:17",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49",
              FUELE1: "49",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:37:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.5",
              FUELE1: "48.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:37:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.5",
              FUELE1: "48.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:37:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.5",
              FUELE1: "48.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:37:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.5",
              FUELE1: "48.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:37:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.9",
              FUELE1: "48.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:37:36",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.9",
              FUELE1: "48.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:37:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.8",
              FUELE1: "49.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:37:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.8",
              FUELE1: "50.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:37:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.7",
              FUELE1: "50.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:37:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.6",
              FUELE1: "48.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:38:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.2",
              FUELE1: "49.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:38:02",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.2",
              FUELE1: "49.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:38:32",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.2",
              FUELE1: "50.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:38:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.1",
              FUELE1: "49.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:38:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.1",
              FUELE1: "49.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:38:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.1",
              FUELE1: "49.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:39:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.8",
              FUELE1: "51.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:39:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51.8",
              FUELE1: "51.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:39:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48",
              FUELE1: "48",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:40:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.5",
              FUELE1: "48.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:40:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:40:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:40:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.1",
              FUELE1: "47.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:41:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.5",
              FUELE1: "47.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:41:19",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.6",
              FUELE1: "47.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:41:20",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.6",
              FUELE1: "47.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:41:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:41:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:41:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:42:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.5",
              FUELE1: "48.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:42:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.1",
              FUELE1: "48.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:43:11",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.1",
              FUELE1: "48.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:43:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.8",
              FUELE1: "49.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:43:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "51",
              FUELE1: "51",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:43:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.9",
              FUELE1: "49.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:44:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.6",
              FUELE1: "48.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:44:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.6",
              FUELE1: "48.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:44:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.2",
              FUELE1: "49.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:44:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.2",
              FUELE1: "49.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:44:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.1",
              FUELE1: "45.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:44:49",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "41.8",
              FUELE1: "41.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:44:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "41.8",
              FUELE1: "41.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:44:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "41.8",
              FUELE1: "42.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:45:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.9",
              FUELE1: "48.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:45:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.7",
              FUELE1: "47.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:45:33",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.7",
              FUELE1: "47.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:46:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.7",
              FUELE1: "48.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:46:33",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.1",
              FUELE1: "49.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:46:38",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.4",
              FUELE1: "49.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:46:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.4",
              FUELE1: "49.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:46:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.9",
              FUELE1: "48.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:46:50",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.9",
              FUELE1: "48.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:46:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.7",
              FUELE1: "47.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:46:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.7",
              FUELE1: "47.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:47:11",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.9",
              FUELE1: "45.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:47:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.9",
              FUELE1: "46.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:47:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.6",
              FUELE1: "47.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:47:49",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.9",
              FUELE1: "47.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:47:50",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.8",
              FUELE1: "47.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:47:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.5",
              FUELE1: "47.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:47:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.5",
              FUELE1: "47.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:48:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47",
              FUELE1: "47",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:48:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.7",
              FUELE1: "47.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:48:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.7",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:49:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49",
              FUELE1: "49",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:49:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.1",
              FUELE1: "48.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:49:17",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.1",
              FUELE1: "48.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:49:47",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48",
              FUELE1: "48",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:50:17",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.2",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:50:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.1",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:50:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.1",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:50:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.1",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:50:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.1",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:50:33",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.1",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:50:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.1",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:51:02",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.1",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:51:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:51:11",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:51:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:51:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:51:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:51:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:51:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:51:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:51:33",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:51:50",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:51:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:51:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:51:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:52:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:52:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:52:18",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:52:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:52:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:52:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:52:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:52:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:52:43",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:52:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "14",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:52:47",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:52:49",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:52:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:52:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:53:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:53:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:53:19",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:53:20",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:53:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:53:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:53:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:53:47",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:53:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:53:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:53:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:54:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:54:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:54:19",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:54:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:54:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:54:33",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:55:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:55:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:55:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:55:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:56:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:56:18",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:56:20",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:56:50",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:56:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:56:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:57:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:57:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:58:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:58:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:58:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "14",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:58:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:58:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:59:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:59:19",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:59:20",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T12:59:50",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:00:20",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:00:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:00:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:01:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:01:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:02:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:02:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:02:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:02:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:02:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:02:43",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:02:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:03:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:03:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:04:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:04:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:05:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:05:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:06:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:06:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:07:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:07:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:08:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:08:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:09:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:09:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:10:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:10:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:11:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:11:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:12:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:12:19",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:12:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:12:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:13:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:13:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:14:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:14:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:15:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:15:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:15:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.3",
              FUELE1: "48.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:15:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:16:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:16:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.2",
              FUELE1: "48.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:17:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.1",
              FUELE1: "48.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:17:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.1",
              FUELE1: "48.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:17:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.1",
              FUELE1: "48.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:17:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.1",
              FUELE1: "48.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:18:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.1",
              FUELE1: "48.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:18:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48",
              FUELE1: "48",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:19:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48",
              FUELE1: "48",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:19:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48",
              FUELE1: "48",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:19:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48",
              FUELE1: "48",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:19:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48",
              FUELE1: "48",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:20:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48",
              FUELE1: "48",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:20:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48",
              FUELE1: "48",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:21:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48",
              FUELE1: "48",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:21:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.9",
              FUELE1: "47.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:22:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.9",
              FUELE1: "47.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:22:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.9",
              FUELE1: "47.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:23:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.9",
              FUELE1: "47.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:23:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.8",
              FUELE1: "47.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:24:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.8",
              FUELE1: "47.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:24:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.8",
              FUELE1: "47.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:25:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.7",
              FUELE1: "47.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:25:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.7",
              FUELE1: "47.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:26:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.7",
              FUELE1: "47.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:26:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.7",
              FUELE1: "47.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:26:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.7",
              FUELE1: "47.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:26:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.7",
              FUELE1: "47.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:27:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.7",
              FUELE1: "47.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:27:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.7",
              FUELE1: "47.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:28:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.6",
              FUELE1: "47.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:28:32",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.6",
              FUELE1: "47.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:28:33",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.6",
              FUELE1: "47.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:29:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.6",
              FUELE1: "47.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:29:11",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.6",
              FUELE1: "47.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:29:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.6",
              FUELE1: "47.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:29:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.6",
              FUELE1: "47.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:29:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.6",
              FUELE1: "47.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:29:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.5",
              FUELE1: "47.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:30:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.5",
              FUELE1: "47.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:30:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.5",
              FUELE1: "47.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:30:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.5",
              FUELE1: "47.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:31:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.5",
              FUELE1: "47.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:31:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.4",
              FUELE1: "47.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:32:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.4",
              FUELE1: "47.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:32:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.4",
              FUELE1: "47.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:32:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.4",
              FUELE1: "47.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:32:38",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.4",
              FUELE1: "47.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:33:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.4",
              FUELE1: "47.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:33:38",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.4",
              FUELE1: "47.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:34:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.4",
              FUELE1: "47.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:34:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.4",
              FUELE1: "47.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:34:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.4",
              FUELE1: "47.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:34:43",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.3",
              FUELE1: "47.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:34:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.3",
              FUELE1: "47.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:34:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.3",
              FUELE1: "47.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:35:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.3",
              FUELE1: "47.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:35:38",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.3",
              FUELE1: "47.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:35:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.3",
              FUELE1: "47.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:36:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.2",
              FUELE1: "47.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:36:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.2",
              FUELE1: "47.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:36:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.2",
              FUELE1: "47.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:36:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.2",
              FUELE1: "47.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "14",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:37:02",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.2",
              FUELE1: "47.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:37:32",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.1",
              FUELE1: "47.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:37:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.1",
              FUELE1: "47.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:37:43",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.1",
              FUELE1: "47.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:38:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.1",
              FUELE1: "47.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:38:43",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.1",
              FUELE1: "47.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:38:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.1",
              FUELE1: "47.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:38:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.1",
              FUELE1: "47.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:39:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.1",
              FUELE1: "47.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:39:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.1",
              FUELE1: "47.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:39:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.1",
              FUELE1: "47.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:40:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.1",
              FUELE1: "47.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:40:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.1",
              FUELE1: "47.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:40:06",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.1",
              FUELE1: "47.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:40:36",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47",
              FUELE1: "47",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:40:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47",
              FUELE1: "47",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:40:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47",
              FUELE1: "47",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:41:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47",
              FUELE1: "47",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:41:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47",
              FUELE1: "47",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:41:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47",
              FUELE1: "47",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:41:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.9",
              FUELE1: "46.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:41:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.9",
              FUELE1: "46.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:42:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.9",
              FUELE1: "46.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:42:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.9",
              FUELE1: "46.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:43:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.9",
              FUELE1: "46.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:43:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.9",
              FUELE1: "46.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:44:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.9",
              FUELE1: "46.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:44:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.9",
              FUELE1: "46.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:45:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.8",
              FUELE1: "46.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:45:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.8",
              FUELE1: "46.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:46:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.8",
              FUELE1: "46.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:46:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.7",
              FUELE1: "46.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:46:38",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.7",
              FUELE1: "46.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:46:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.7",
              FUELE1: "46.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:47:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.7",
              FUELE1: "46.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:47:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.6",
              FUELE1: "46.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:48:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.6",
              FUELE1: "46.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:48:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.6",
              FUELE1: "46.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:49:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.6",
              FUELE1: "46.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:49:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.6",
              FUELE1: "46.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:50:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.6",
              FUELE1: "46.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:50:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.6",
              FUELE1: "46.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:51:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.5",
              FUELE1: "46.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:51:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.5",
              FUELE1: "46.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:52:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.5",
              FUELE1: "46.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:52:19",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.4",
              FUELE1: "46.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:52:20",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.4",
              FUELE1: "46.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:52:50",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.4",
              FUELE1: "46.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:52:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.4",
              FUELE1: "46.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:52:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.4",
              FUELE1: "46.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:53:23",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.4",
              FUELE1: "46.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:53:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.4",
              FUELE1: "46.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:53:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.4",
              FUELE1: "46.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:53:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.3",
              FUELE1: "46.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:54:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.3",
              FUELE1: "46.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:54:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.3",
              FUELE1: "46.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:55:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.3",
              FUELE1: "46.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:55:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.3",
              FUELE1: "46.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:56:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.3",
              FUELE1: "46.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:56:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.2",
              FUELE1: "46.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:57:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.2",
              FUELE1: "46.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:57:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.2",
              FUELE1: "46.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:57:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.2",
              FUELE1: "46.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:58:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.2",
              FUELE1: "46.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:58:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.1",
              FUELE1: "46.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:59:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.1",
              FUELE1: "46.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T13:59:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.1",
              FUELE1: "46.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:00:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46",
              FUELE1: "46",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:00:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46",
              FUELE1: "46",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:01:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46",
              FUELE1: "46",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:01:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46",
              FUELE1: "46",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:02:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46",
              FUELE1: "46",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:02:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46",
              FUELE1: "46",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:03:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.9",
              FUELE1: "45.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:03:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.9",
              FUELE1: "45.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:04:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.9",
              FUELE1: "45.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:04:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.8",
              FUELE1: "45.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:05:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.8",
              FUELE1: "45.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:05:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.8",
              FUELE1: "45.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:06:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.7",
              FUELE1: "45.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:06:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.7",
              FUELE1: "45.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:07:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.7",
              FUELE1: "45.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:07:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.7",
              FUELE1: "45.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:07:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.7",
              FUELE1: "45.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:07:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.7",
              FUELE1: "45.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:08:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.7",
              FUELE1: "45.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:08:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.7",
              FUELE1: "45.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:09:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.6",
              FUELE1: "45.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:09:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.6",
              FUELE1: "45.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:09:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.6",
              FUELE1: "45.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:09:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.6",
              FUELE1: "45.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:10:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.6",
              FUELE1: "45.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:10:05",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.6",
              FUELE1: "45.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:10:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.6",
              FUELE1: "45.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:10:11",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.6",
              FUELE1: "45.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:10:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:10:50",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:10:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:11:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.1",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:11:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:12:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:12:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:13:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.9",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:13:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:14:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:14:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:15:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:15:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.8",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:16:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:16:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:17:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:17:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:18:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:18:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:19:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:19:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:20:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:20:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:21:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:21:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:22:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:22:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:23:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:23:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:24:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:24:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:25:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:25:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:26:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:26:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:27:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:27:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:28:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:28:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:29:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:29:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:30:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:30:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:31:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:31:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:32:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:32:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:33:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:33:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:34:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:34:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:35:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:35:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:36:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:36:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:37:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:37:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:38:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:38:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:39:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:39:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:39:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:39:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.1",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:39:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "45.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.3",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:40:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.7",
              FUELE1: "45.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:40:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "41.6",
              FUELE1: "41.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:41:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "41.4",
              FUELE1: "41.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:41:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "41.7",
              FUELE1: "41.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:41:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "41.7",
              FUELE1: "41.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:41:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "41.7",
              FUELE1: "41.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:42:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "41.6",
              FUELE1: "41.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:42:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "41.1",
              FUELE1: "41.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:43:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "43.8",
              FUELE1: "43.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:43:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "43.8",
              FUELE1: "43.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:43:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "43.2",
              FUELE1: "43.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:43:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "42.7",
              FUELE1: "42.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:43:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "42.7",
              FUELE1: "42.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:44:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "44.2",
              FUELE1: "44.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:44:17",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "44.2",
              FUELE1: "44.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:44:19",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "44.2",
              FUELE1: "44.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:44:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "40.1",
              FUELE1: "40.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:44:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "40.1",
              FUELE1: "40.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:44:38",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "37.3",
              FUELE1: "37.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:44:43",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "36.2",
              FUELE1: "36.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:44:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "36.2",
              FUELE1: "36.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:44:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "40",
              FUELE1: "40",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:44:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "40",
              FUELE1: "40",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:44:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "40.4",
              FUELE1: "50",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:45:00",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50",
              FUELE1: "50",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:45:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.9",
              FUELE1: "48.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:45:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "5",
              FUELE: "48.4",
              FUELE1: "48.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:45:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "4",
              FUELE: "48.2",
              FUELE1: "42.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:45:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "3",
              FUELE: "46.3",
              FUELE1: "42.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:45:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.5",
              FUELE1: "42.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:45:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "41.5",
              FUELE1: "41.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:45:18",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "41.5",
              FUELE1: "41.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:45:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.2",
              FUELE1: "47.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:45:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47.2",
              FUELE1: "47.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:45:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.9",
              FUELE1: "45.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:45:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.9",
              FUELE1: "45.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:45:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "43.1",
              FUELE1: "43.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:45:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "43.1",
              FUELE1: "43.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:46:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "44.4",
              FUELE1: "44.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:46:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "43.2",
              FUELE1: "43.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:46:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "43.2",
              FUELE1: "43.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:46:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "44.5",
              FUELE1: "44.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:46:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "44.5",
              FUELE1: "44.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:46:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "42.8",
              FUELE1: "42.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:47:02",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.8",
              FUELE1: "46.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:47:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.8",
              FUELE1: "46.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:47:33",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "44",
              FUELE1: "44",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:47:49",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.1",
              FUELE1: "45.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:47:50",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.1",
              FUELE1: "45.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:47:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.1",
              FUELE1: "45.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:47:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "45.1",
              FUELE1: "45.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:48:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "44.2",
              FUELE1: "44.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:48:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "44.2",
              FUELE1: "44.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:48:19",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "44.2",
              FUELE1: "44.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:48:20",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "44.2",
              FUELE1: "44.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:48:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "44.2",
              FUELE1: "44.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:48:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "44.2",
              FUELE1: "44.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:48:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "44.1",
              FUELE1: "44.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:48:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "44.1",
              FUELE1: "44.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:48:43",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "44.1",
              FUELE1: "44.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:48:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "44.1",
              FUELE1: "44.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:48:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "44.3",
              FUELE1: "44.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.3",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:48:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "44.4",
              FUELE1: "46.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:48:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.9",
              FUELE1: "46.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:48:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.9",
              FUELE1: "46.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:48:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.9",
              FUELE1: "46.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:48:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.9",
              FUELE1: "46.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:48:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.9",
              FUELE1: "46.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:49:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "44.3",
              FUELE1: "44.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:49:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "43.6",
              FUELE1: "43.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:50:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "43.7",
              FUELE1: "43.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:50:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "43.7",
              FUELE1: "43.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:50:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "43.3",
              FUELE1: "43.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:51:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "42.9",
              FUELE1: "42.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:51:43",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "43.2",
              FUELE1: "43.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:52:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.9",
              FUELE1: "46.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:52:20",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.4",
              FUELE1: "48.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:52:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "48.4",
              FUELE1: "48.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:52:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.6",
              FUELE1: "49.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:52:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "49.5",
              FUELE1: "47",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:52:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "47",
              FUELE1: "47",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:52:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "46.9",
              FUELE1: "45.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:53:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "41.3",
              FUELE1: "41.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:53:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "42.9",
              FUELE1: "42.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:53:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "42.9",
              FUELE1: "42.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:53:19",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "43",
              FUELE1: "43.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:53:20",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "43.3",
              FUELE1: "43.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:53:21",
              IGNI: "True",
              TE: "50",
              FUEF: "0",
              SPEE: "0",
              FUELE: "43.3",
              FUELE1: "43.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:53:46",
              IGNI: "True",
              TE: "50",
              FUEF: "0",
              SPEE: "0",
              FUELE: "41.7",
              FUELE1: "41.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:53:50",
              IGNI: "True",
              TE: "50",
              FUEF: "0",
              SPEE: "0",
              FUELE: "41.8",
              FUELE1: "43.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:53:57",
              IGNI: "True",
              TE: "50",
              FUEF: "0",
              SPEE: "0",
              FUELE: "40.8",
              FUELE1: "40.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:54:00",
              IGNI: "True",
              TE: "50",
              FUEF: "0",
              SPEE: "0",
              FUELE: "40.8",
              FUELE1: "40.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:54:07",
              IGNI: "True",
              TE: "50",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.8",
              FUELE1: "39.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:54:08",
              IGNI: "True",
              TE: "50",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.8",
              FUELE1: "39.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:54:18",
              IGNI: "True",
              TE: "50",
              FUEF: "0",
              SPEE: "0",
              FUELE: "38.9",
              FUELE1: "38.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:54:19",
              IGNI: "True",
              TE: "50",
              FUEF: "0",
              SPEE: "0",
              FUELE: "38.9",
              FUELE1: "38.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:54:20",
              IGNI: "True",
              TE: "60",
              FUEF: "0",
              SPEE: "0",
              FUELE: "38.8",
              FUELE1: "36.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:54:25",
              IGNI: "True",
              TE: "45",
              FUEF: "0",
              SPEE: "0",
              FUELE: "36.4",
              FUELE1: "36.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:54:26",
              IGNI: "True",
              TE: "45",
              FUEF: "0",
              SPEE: "0",
              FUELE: "36.4",
              FUELE1: "36.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:54:30",
              IGNI: "True",
              TE: "45",
              FUEF: "0",
              SPEE: "0",
              FUELE: "36.4",
              FUELE1: "36.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:54:32",
              IGNI: "True",
              TE: "45",
              FUEF: "0",
              SPEE: "0",
              FUELE: "36.4",
              FUELE1: "36.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:54:34",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "37.4",
              FUELE1: "37.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:54:36",
              IGNI: "True",
              TE: "40",
              FUEF: "0",
              SPEE: "0",
              FUELE: "37.4",
              FUELE1: "37.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:54:40",
              IGNI: "True",
              TE: "40",
              FUEF: "0",
              SPEE: "0",
              FUELE: "37.4",
              FUELE1: "37.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:54:41",
              IGNI: "True",
              TE: "40",
              FUEF: "0",
              SPEE: "0",
              FUELE: "37.4",
              FUELE1: "37.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:54:48",
              IGNI: "True",
              TE: "40",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.2",
              FUELE1: "39.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:55:04",
              IGNI: "True",
              TE: "40",
              FUEF: "0",
              SPEE: "0",
              FUELE: "41.9",
              FUELE1: "41.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:55:05",
              IGNI: "True",
              TE: "40",
              FUEF: "0",
              SPEE: "0",
              FUELE: "41.9",
              FUELE1: "41.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:55:07",
              IGNI: "True",
              TE: "40",
              FUEF: "0",
              SPEE: "3",
              FUELE: "42.3",
              FUELE1: "42.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:55:10",
              IGNI: "True",
              TE: "40",
              FUEF: "0",
              SPEE: "3",
              FUELE: "42.3",
              FUELE1: "42.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:55:12",
              IGNI: "True",
              TE: "40",
              FUEF: "0",
              SPEE: "5",
              FUELE: "41.6",
              FUELE1: "38.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:55:13",
              IGNI: "True",
              TE: "45",
              FUEF: "0",
              SPEE: "0",
              FUELE: "41",
              FUELE1: "38.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:55:43",
              IGNI: "True",
              TE: "40",
              FUEF: "0",
              SPEE: "0",
              FUELE: "38.8",
              FUELE1: "38.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "20",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:56:13",
              IGNI: "True",
              TE: "40",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39",
              FUELE1: "39",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "22",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:56:20",
              IGNI: "True",
              TE: "40",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39",
              FUELE1: "39",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "21",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:56:22",
              IGNI: "True",
              TE: "45",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39",
              FUELE1: "39.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "22",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:56:52",
              IGNI: "True",
              TE: "40",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.1",
              FUELE1: "39.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "20",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:57:00",
              IGNI: "True",
              TE: "40",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.1",
              FUELE1: "39.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "21",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:57:01",
              IGNI: "True",
              TE: "40",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.1",
              FUELE1: "39.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "21",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:57:06",
              IGNI: "True",
              TE: "40",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.1",
              FUELE1: "39.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "21",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:57:07",
              IGNI: "True",
              TE: "40",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.1",
              FUELE1: "39.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "22",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:57:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.1",
              FUELE1: "39.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "22",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:57:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.2",
              FUELE1: "39.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "21",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:57:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.2",
              FUELE1: "39.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "22",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:58:18",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.1",
              FUELE1: "39.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "21",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:58:27",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.1",
              FUELE1: "39.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "22",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:58:29",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.1",
              FUELE1: "39.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "22",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:58:59",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.1",
              FUELE1: "39.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "21",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:59:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.2",
              FUELE1: "39.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.3",
              SATE: "21",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:59:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.2",
              FUELE1: "39.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.3",
              SATE: "21",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:59:16",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.2",
              FUELE1: "39.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:59:17",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.2",
              FUELE1: "39.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:59:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "3",
              FUELE: "39",
              FUELE1: "39",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:59:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "4",
              FUELE: "39",
              FUELE1: "39.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:59:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "5",
              FUELE: "39.1",
              FUELE1: "39.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:59:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39",
              FUELE1: "38.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:59:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.2",
              FUELE1: "39.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "17",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:59:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.2",
              FUELE1: "39.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:59:50",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39.2",
              FUELE1: "39.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:59:55",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "39",
              FUELE1: "38.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T14:59:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "38.9",
              FUELE1: "38.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:00:28",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "42.7",
              FUELE1: "42.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "22",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:00:58",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "41.9",
              FUELE1: "41.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "21",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:01:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "42.1",
              FUELE1: "42.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "21",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:01:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "42.1",
              FUELE1: "42.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "22",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:01:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "42",
              FUELE1: "42",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "22",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:02:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "41.9",
              FUELE1: "41.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "21",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:02:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "50.5",
              FUELE1: "50.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "22",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:03:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "68.7",
              FUELE1: "68.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "22",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:03:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "82.6",
              FUELE1: "82.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "22",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:04:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "107",
              FUELE1: "107",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "22",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:04:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "118.6",
              FUELE1: "118.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "22",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:05:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "136.3",
              FUELE1: "136.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "22",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:05:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "155.2",
              FUELE1: "155.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "22",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:06:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "169.8",
              FUELE1: "169.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "22",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:06:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "188.1",
              FUELE1: "188.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "21",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:07:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "206.9",
              FUELE1: "206.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.3",
              SATE: "22",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:07:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "221.8",
              FUELE1: "221.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "21",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:08:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "234.2",
              FUELE1: "234.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "22",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:08:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "234.2",
              FUELE1: "234.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "22",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:09:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "234.2",
              FUELE1: "234.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.2",
              SATE: "21",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:09:38",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "234.4",
              FUELE1: "234.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.3",
              SATE: "20",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:09:43",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "234.8",
              FUELE1: "234.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:09:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "234.8",
              FUELE1: "234.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.3",
              SATE: "18",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:09:50",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "234.6",
              FUELE1: "234.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:09:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "233.6",
              FUELE1: "233.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "True",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:09:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "233.6",
              FUELE1: "233.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:09:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "233.6",
              FUELE1: "233.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:10:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "234.5",
              FUELE1: "234.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:10:33",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "232.2",
              FUELE1: "232.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.6",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:11:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "232.5",
              FUELE1: "232.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:11:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "232.5",
              FUELE1: "232.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:11:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "232.5",
              FUELE1: "232.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:11:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "232.9",
              FUELE1: "234.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:11:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "236.3",
              FUELE1: "236.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:12:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "234.6",
              FUELE1: "234.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:12:45",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "234.6",
              FUELE1: "234.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:13:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "236.3",
              FUELE1: "236.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:13:26",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "238.7",
              FUELE1: "238.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:13:32",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "239.5",
              FUELE1: "239.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:13:37",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "240.2",
              FUELE1: "240.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:13:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "234.9",
              FUELE1: "234.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:14:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "234",
              FUELE1: "234",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:14:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "234",
              FUELE1: "234",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:14:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "233.8",
              FUELE1: "233",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:14:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "233",
              FUELE1: "233",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:14:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "232.9",
              FUELE1: "232.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:14:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "236.5",
              FUELE1: "236.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:14:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "235",
              FUELE1: "235",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:15:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "234.7",
              FUELE1: "234.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:15:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "234.8",
              FUELE1: "234.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:16:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "238.4",
              FUELE1: "238.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:16:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "239",
              FUELE1: "239",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:16:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "237.2",
              FUELE1: "237.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:16:25",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "237.2",
              FUELE1: "237.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:16:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "237.1",
              FUELE1: "234.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:16:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "236.3",
              FUELE1: "234.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:16:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "235.4",
              FUELE1: "235.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "15",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:16:56",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "235.4",
              FUELE1: "235.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.3",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:16:57",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "235.4",
              FUELE1: "235.4",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:17:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "235.3",
              FUELE1: "233.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.3",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:17:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "234.8",
              FUELE1: "233.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:17:07",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "232.2",
              FUELE1: "232.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:17:08",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "232.2",
              FUELE1: "232.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:17:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "232.3",
              FUELE1: "235.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:17:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "235.9",
              FUELE1: "235.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:17:51",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "235.1",
              FUELE1: "235.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:17:54",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "235.1",
              FUELE1: "235.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:18:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "231.7",
              FUELE1: "231.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:18:32",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "231.7",
              FUELE1: "231.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:18:35",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "231.7",
              FUELE1: "231.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:18:46",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "231.6",
              FUELE1: "231.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:18:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "231.6",
              FUELE1: "231.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:19:18",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "231.6",
              FUELE1: "231.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:19:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "231.6",
              FUELE1: "231.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:19:32",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "231.6",
              FUELE1: "231.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:20:02",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "232.9",
              FUELE1: "232.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:20:14",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "235.1",
              FUELE1: "235.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:20:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "235.1",
              FUELE1: "235.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:20:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "233.1",
              FUELE1: "233.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:20:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "229",
              FUELE1: "229",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:20:32",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "229",
              FUELE1: "229",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:20:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "226.7",
              FUELE1: "226.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:20:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "226.7",
              FUELE1: "226.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:20:50",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "225.6",
              FUELE1: "225.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:21:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "223.6",
              FUELE1: "223.6",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:21:06",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "223.6",
              FUELE1: "224.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:21:36",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "228.5",
              FUELE1: "228.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:21:39",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "3",
              FUELE: "229",
              FUELE1: "229",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:21:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "5",
              FUELE: "229",
              FUELE1: "229",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:21:44",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "9",
              FUELE: "229",
              FUELE1: "229",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:21:48",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "229.1",
              FUELE1: "229.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:21:49",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "229.3",
              FUELE1: "229.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:21:53",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "229.4",
              FUELE1: "229.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:22:03",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "231.8",
              FUELE1: "231.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:22:04",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "231.6",
              FUELE1: "230.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:22:09",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "230.7",
              FUELE1: "230.7",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:22:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "230.5",
              FUELE1: "229.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "17",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:22:15",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "230.4",
              FUELE1: "229.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:22:20",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "231.9",
              FUELE1: "231.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:22:21",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "231.9",
              FUELE1: "231.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:22:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "231.9",
              FUELE1: "231.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:22:38",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "235.5",
              FUELE1: "235.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:22:40",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "235.5",
              FUELE1: "235.5",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:23:10",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "233.2",
              FUELE1: "233.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:23:13",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "233.2",
              FUELE1: "233.2",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:23:17",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "233.1",
              FUELE1: "231.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:23:20",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "231.9",
              FUELE1: "227.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:23:24",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "227.3",
              FUELE1: "227.3",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.4",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:23:30",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "228.9",
              FUELE1: "228.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:23:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "228.9",
              FUELE1: "228.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "16",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:24:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "230.9",
              FUELE1: "230.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "18",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:24:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "230.1",
              FUELE1: "230.1",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "19",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:25:01",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "229.8",
              FUELE1: "229.8",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "27.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:25:31",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "230",
              FUELE1: "230",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:25:41",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "229.9",
              FUELE1: "229.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:25:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "229.9",
              FUELE1: "229.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.7",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:26:12",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "229.9",
              FUELE1: "229.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:26:42",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "229.9",
              FUELE1: "229.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "22",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:26:50",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "229.9",
              FUELE1: "229.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.6",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:26:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "229.9",
              FUELE1: "229.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:27:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "229.9",
              FUELE1: "229.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:27:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "229.9",
              FUELE1: "229.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "20",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:28:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "229.9",
              FUELE1: "229.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:28:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "229.9",
              FUELE1: "229.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.5",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:29:22",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "229.9",
              FUELE1: "229.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
            {
              TI: "2024-12-09T15:29:52",
              IGNI: "True",
              TE: "0",
              FUEF: "0",
              SPEE: "0",
              FUELE: "229.9",
              FUELE1: "229.9",
              FUELE2: "0",
              FUELE3: "0",
              VOL: "26.4",
              SATE: "21",
              FUEUP: "False",
              FUEDW: "False",
            },
          ],
          pivot: {},
          dashboard: {},
        },
      ],
      pivot: {},
      dashboard: {},
    },
  ],
  pivot: {},
};
